import { Component, OnInit, OnDestroy } from '@angular/core';
import { Message } from 'primeng/primeng';
import { NotificationsService } from './notifications.service';
import { Subscription } from 'rxjs/Subscription';
import { MessageService } from 'primeng/components/common/messageservice';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit, OnDestroy {
  messages: Message[] = [];
  subscription: Subscription;

  constructor(private notificationsService: NotificationsService,
    private messageService: MessageService) { }

  ngOnInit() {
    this.subscribeToNotifications();
  }

  subscribeToNotifications() {
    this.subscription = this.notificationsService.notificationChange
      .subscribe((notification: Message) => {
        notification.key = new Date().toString();
        //this.messages.length = 0;  // Forces to only have 1 at a time!
        // this.messages = [...this.messages, notification];

        this.messageService.add(notification);
        // this.messages.push(notification);
      });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}


// WEBPACK FOOTER //
// ./src/app/core/notifications/notifications.component.ts